import React, {Ref, useEffect, useImperativeHandle, useState} from "react";
import {fields} from "./config";
import {Form} from "antd";
import {
  convertIosStringToDate,
  convertDateStringToDateTimezone_7,
  formatDateToString,
} from "helper/common";
import moment from "moment";
import PatientInfoCommon from "components/common/PatientInfoCommon/PatientInfoCommon";
import dayjs from "dayjs";

export type PatientInfoRef = {
  getFormValue: () => any;
};

type Props = {
  detailConsultantAndFragment: any;
  ref?: Ref<PatientInfoRef>;
};
const PatientInfo = React.forwardRef<PatientInfoRef, Props>((props, ref) => {
  const {detailConsultantAndFragment} = props;
  const [form] = Form.useForm();
  //set lai value
  useEffect(() => {
    form.setFieldsValue({
      ...detailConsultantAndFragment,
      loaiPhauThuat: detailConsultantAndFragment?.loaiPhauThuat ?? [],
      ngayTao: convertDateStringToDateTimezone_7(
        detailConsultantAndFragment?.ngayTao
      ),
      tuoi:
        moment().year() -
        convertIosStringToDate(detailConsultantAndFragment?.ngaySinh)?.year(),
      nvTuVan:
        detailConsultantAndFragment?.nvTuVan ??
        localStorage.getItem("fullName"),
    });
  }, [detailConsultantAndFragment]);

  const formatFormValue = () => {
    const rawValues = form.getFieldsValue();
    const formatValues = {
      ...rawValues,
      ngaySinh: formatDateToString(rawValues.ngaySinh, null),
    };
    // console.log(formatValues);
    return formatValues;
  };

  useImperativeHandle(ref, () => ({
    getFormValue: () => {
      return formatFormValue();
    },
  }));

  return (
    <div className="patient-info">
      <Form labelAlign="left" form={form}>
        <PatientInfoCommon
          data={detailConsultantAndFragment}
          fields={fields()}
        />
      </Form>
    </div>
  );
});
export default PatientInfo;
